import React, { useLayoutEffect, useRef } from 'react';

export default function NavigationArrow({ onClick, ...props }) {
  const enabledAt = useRef(Infinity);

  useLayoutEffect(() => {
    enabledAt.current = Date.now() + 500;
  }, []);

  return <div {...props} onClick={event => {
    if (Date.now() >= enabledAt.current) onClick(event);
  }}/>;
}
